import { useState, useEffect, useCallback } from "react";
import { Routes, Route } from "react-router-dom";
import styles from "./App.module.scss";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Landing from "./views/landing/Landing";
import Contact from "./views/contact/Contact";

function App() {
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    image: null,
    alt: null,
  });

  const openImageModal = (image, alt) => {
    setImageModal({ ...imageModal, isOpen: true, image: image, alt: alt });
  };

  const closeImageModal = useCallback(() => {
    setImageModal({ ...imageModal, isOpen: false });
  }, [imageModal]);

  const modal = () => (
    <div onClick={closeImageModal} className={styles.modal}>
      <div className={styles.image}>
        <img alt={imageModal.alt} src={imageModal.image} />
      </div>
    </div>
  );

  useEffect(() => {
    if (imageModal.isOpen) {
      window.addEventListener("keydown", (e) => {
        if (e.keyCode === 27) {
          closeImageModal();
        }
      });
    }
  }, [imageModal, closeImageModal]);

  return (
    <div className={styles.app}>
      {imageModal.isOpen && modal()}
      <Header links={[{ href: "/contact", text: "Kontakt" }]} />
      <Routes>
        <Route path="/" element={<Landing openImageModal={openImageModal} />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
